import React, { useCallback, useState } from 'react';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-light-svg-icons';

interface CopyButtonProps {
  text: string | JSX.Element;
  onCopy: (onCallback?: () => unknown) => unknown;
}

const CopyButton: React.FC<CopyButtonProps> = ({ text, onCopy }) => {
  const [showCopied, setShowCopied] = useState<boolean>(false);

  const onCallback = useCallback(() => {
    setShowCopied(true);
    window.setTimeout(() => {
      setShowCopied(false);
    }, 3000);
  }, [setShowCopied]);

  const handleClick = useCallback(() => {
    onCopy(onCallback);
  }, [onCallback]);

  return (
    <TrueImpactButton
      variant="secondary-small"
      color={showCopied ? 'grayBase' : undefined}
      onClick={handleClick}
      disabled={showCopied}
    >
      <FontAwesomeIcon icon={faCopy} />
      {showCopied ? 'Copied' : text}
    </TrueImpactButton>
  );
};

export default CopyButton;
